<template>
<div>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
            <vx-card title="Clientes x Fase Estrategia">
                <vue-apex-charts type="donut" height="300" :options="donutChart.chartOptions" :series="donutChart.series"></vue-apex-charts>
            </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
            <vx-card title="Clientes x Rango Deuda">
                <vue-apex-charts type="pie" height="300" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>
            </vx-card>
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
            <vx-card title="Indicadores">
                <vue-apex-charts type="bar" height="300" :options="barChartVertical.chartOptions" :series="barChartVertical.series"></vue-apex-charts>
            </vx-card>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-base">
            <vx-card title="Cantidad Mensajes X Cantidad Clientes">
                <vue-apex-charts type="radialBar" height="340" :options="radialBarChart.chartOptions" :series="radialBarChart.series"></vue-apex-charts>
            </vx-card>
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card title="Clientes x Plazo Elegido">
                <vue-apex-charts type="bar" height="600" :options="barChartHorizontal.chartOptions" :series="barChartHorizontal.series"></vue-apex-charts>
            </vx-card>
        </div>        
    </div>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import ChartjsComponentLineChart from './charts-components/ChartjsComponentLineChart.vue'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import analyticsData from './analyticsData.js'
import apexChatData from './apexChartData.js'
const themeColors = ['#28C76F', '#EA5455', '#7367F0', '#FF9F43', '#1E1E1E']
export default {
    components: {
        VueApexCharts,
        ChartjsComponentLineChart,
        StatisticsCardLine,
        ChangeTimeDurationDropdown,
        VxTimeline
    },
    data() {
        return {
            donutChart: {
                series: [0, 0, 0, 0],
                chartOptions: {
                    labels: ['Fase 1', 'Fase 2', 'Fase 3', 'Ninguno'],
                    colors: themeColors,
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            },
            pieChart: {
                series: [0, 0, 0, 0],
                chartOptions: {
                    labels: ['0 - 10.000', '10.001 - 20.000', '20.000 - ∞', 'Ninguno'],
                    colors: themeColors,
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            },
            barChartVertical: {
                series: [{
                    name: '',
                    data: [0, 0, 0, 0, 0, 0]
                }],
                chartOptions: {
                    labels: ['Ya pague','No es mi deuda','No estoy de acuerdo','Confirmar Acuerdo','Difícil Situación','Hablar con Asesor'],
                    colors: themeColors,
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    },
                }
            },
            barChartHorizontal: {
                series: [{
                    name: '1',
                    data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                }, {
                    name: '2',
                    data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
                }],
                chartOptions: {
                    chart: {
                        type: 'bar',
                        height: 350,
                        stacked: true
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                total: {
                                    enabled: true,
                                    offsetX: 0,
                                    style: {
                                        fontSize: '13px',
                                        fontWeight: 900
                                    }
                                }
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    xaxis: {
                        categories: ['Campaña 1','Campaña 2','Campaña 3','Campaña 4','Campaña 5','Campaña 6','Campaña 7','Campaña 8','Campaña 9','Camapaña 10','Camapaña 11','Camapaña 12','Camapaña 13','Camapaña 14','Camapaña 15','Camapaña 16','Camapaña 17','Camapaña 18', 'Ninguno'],
                        //categories: [12,18,24,30,36,42,48,54,60,66],
                    },
                    yaxis: {
                        title: {
                            text: undefined
                        }
                    },
                    tooltip: {
                        /* y: {
                            formatter: function (val) {
                                return val + "K";
                            }
                        } */
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'left',
                        offsetX: 40
                    },
                    colors: themeColors,
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                    scales: {
                        y: {
                            beginAtZero: true
                        }
                    }
                }
            },
            radarChart: {
                series: [{
                    name: '',
                    data: [0, 0, 0, 0, 0]
                }],
                chartOptions: {
                    colors: themeColors,
                    labels: ['No tengo plata', 'No es mi deuda', 'No me afecta', 'Ya pague', 'Hablar con un asesor']
                }
            },
            radialBarChart: {
                series: [0],
                chartOptions: {
                    colors: themeColors,
                    plotOptions: {
                        radialBar: {
                            dataLabels: {
                                name: {
                                    fontSize: '22px'
                                },
                                value: {
                                    fontSize: '16px'
                                },
                                total: {
                                    show: true,
                                    label: 'Promedio',
                                    formatter() {
                                        return 0;
                                    }
                                }
                            }
                        }
                    },
                    labels: ['Promedio']
                }
            },
            apexChatData,
            analyticsData,
            productsOrder: {},
            salesRadar: {},
            lineChartSimple: {
                series: [{
                    name: 'Plan',
                    data: [0, 0, 0]
                }],
                chartOptions: {
                    chart: {
                        height: 350,
                        zoom: {
                            enabled: false
                        }
                    },
                    colors: themeColors,
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: 'Plan',
                        align: 'left'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        }
                    },
                    xaxis: {
                        categories: ['Plan 1', 'Plan 2', 'Plan 3']
                    }
                }
            },
            lineChartSimpleD: {
                series: [{
                    name: 'Estado',
                    data: [0, 0]
                }],
                chartOptions: {
                    chart: {
                        height: 350,
                        zoom: {
                            enabled: false
                        }
                    },
                    colors: themeColors,
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: 'Plan',
                        align: 'left'
                    },
                    grid: {
                        row: {
                            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                            opacity: 0.5
                        }
                    },
                    xaxis: {
                        categories: ['Aprobado', 'Rechazado']
                    }
                }
            },
            data: {
                labels: [0, 0, 0, 0],
                datasets: [{
                    data: [0, 1, 1, 0],
                    label: 'Plan 1',
                    borderColor: '#7367F0',
                    fill: false
                }, {
                    data: [0, 1, 0, 0],
                    label: 'Plan 2',
                    borderColor: '#28C76F',
                    fill: false
                }, {
                    data: [0, 0, 0, 1],
                    label: 'Plan 3',
                    borderColor: '#EA5455',
                    fill: false
                }]
            },
            options: {
                title: {
                    display: true,
                    text: ''
                }
            }

        }
    },
    async mounted() {
        await this.getCantClienteszxFaseEstrategia();
        await this.getCantClienteszxRangoDeuda();
        await this.getCantTotalIndicadores();
        await this.getCliextesxplazoElegido();
        await this.getMediaMensajesxcantClientes();
    },
    methods: {
        async getCantClienteszxFaseEstrategia(){
            const { data } = await this.$http.get(`${process.env.apiRobocob}/api/clientesxfaseEstrategia`);
            //console.log(data);
            this.donutChart.series = [data.phase1, data.phase2, data.phase3, data.ninguno];
        },

        async getCantClienteszxRangoDeuda(){
            const { data } = await this.$http.get(`${process.env.apiRobocob}/api/clientesxrangoDeuda`);
            //console.log(data);
            this.pieChart.series = [data.range1, data.range2, data.range3, data.ninguno];
        },

        async getCantTotalIndicadores(){
            const { data } = await this.$http.get(`${process.env.apiRobocob}/api/cantTotalIndicadores`);
            //console.log(data);
            this.barChartVertical.series =[{ name: '', data: [data.yaPague, data.noMiDeeuda, data.noDeAcuerdo, data.confirmarAcuerdo, data.dificilSituacion, data.hablarAsesor] }]
        },

        async getCliextesxplazoElegido(){
            const { data } = await this.$http.get(`${process.env.apiRobocob}/api/cliextesxplazoElegido`);
            //console.log(data);
            let series = [];
            Object.entries(data).forEach(([name, values]) => {
                const dataPoints = Array(19).fill(0);
                Object.entries(values).forEach(([index, value]) => {
                    const position = parseInt(index) - 1;
                    if (position >= 0 && position < 19) {
                        dataPoints[position] = value;
                    }
                });
                //console.log(dataPoints);
                series.push({
                    name: 'Fase Reestructuraión ' + name,
                    data: dataPoints
                });
            });
            this.barChartHorizontal.series = series;
        },

        async getMediaMensajesxcantClientes(){
            const { data } = await this.$http.get(`${process.env.apiRobocob}/api/mediaMensajesxcantClientes`);
            //console.log(data);
            this.radialBarChart.chartOptions = {
                colors: themeColors,
                plotOptions: {
                    radialBar: {
                        dataLabels: {
                            name: {
                                fontSize: '22px'
                            },
                            value: {
                                fontSize: '16px'
                            },
                            total: {
                                show: true,
                                label: 'Total',
                                formatter() {
                                    return data.cantMensajes
                                }
                            }
                        }
                    }
                },
                labels: ['Promedio']
            }
            this.radialBarChart.series = [data.mediaMsgsxClient];
        },
    }
}
</script>
